import { useState, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementService from "../../../core/api/api.amusementService";
import _ from "lodash";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SwalMessage from "../_Components/SwalMessage";
import { Link, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import SelectComponent from "../_Components/ReactSelectComponent";
import HTMLInput from "../_Components/HTMLInput";
import ApiRegion from "../../../core/api/api.region";

const CreateEditAmusementServicePromoCategoryCommision = () => {
  const [treeViewData, setTreeViewData] = useState([]);
  const [promoCategory, setPromoCategory] = useState();
  const [amusementGroups, setAmusementGroups] = useState([]);
  const [amusementCities, setAmusementCities] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const {
    handleSubmit,
    getValues,
    setValue,
    register,
    formState: { isSubmitting },
  } = useForm();

  const {
    control: searchControl,
    handleSubmit: handleSearchSubmit,
    formState: { isSubmitting: isSearchSubmitting },
  } = useForm();

  let { id } = useParams();
  const getAmusemntServices = async (cityIdList, groupIdList) => {
    try {
      setLoadingData(true);
      const response = await ApiAmusementService.getAllServices({
        cityIdList: cityIdList,
        groupIdList: groupIdList,
      });
      const apiData2 = response.map((item) => ({
        serviceId: item.id,
        serviceName: item.name,
        amusementServiceReserveItems: item.amusementServiceReserveItems,
      }));
      setTreeViewData(apiData2);
    } catch (error) {
    } finally {
      setLoadingData(false);
    }
  };
  useEffect(() => {
    (async () => {
      try {
        //================Get Cities And Groups
        const [groupsResponse, citiesResponse] = await Promise.all([
          ApiAmusementGroup.getAllGroups(),
          ApiRegion.getAllCity(),
        ]);
        setAmusementGroups(groupsResponse);
        setAmusementCities(citiesResponse);
        //================ Get Promocategorycommision
        // const apiData = await ApiAmusementService.getAllServices();
        // if (!_.isEmpty(apiData)) {
        //   const apiData2 = apiData.map((item) => ({
        //     serviceId: item.id,
        //     serviceName: item.name,
        //     amusementServiceReserveItems: item.amusementServiceReserveItems,
        //   }));

        //setTreeViewData(apiData2);
        // }
        if (id !== undefined) {
          let response = await ApiPromocategorycommision.getPromoCategoryCommissionAmusementServiceById({ id });
          if (!_.isEmpty(response)) {
            setPromoCategory(response.promoCategoryName);
            //پرکردن آیتم ها
            let tt = response?.getPromoCategoryByIdViewModel.map((item) => {
              let parsAmusementServiceFormFieldIds = JSON.parse(item.amusementServiceFormFieldIds);
              let tt = parsAmusementServiceFormFieldIds?.map((nodes) => {
                if (nodes.discountprice != 0)
                  setValue(item.amusementServiceId + "pricediscount" + nodes.id, nodes.discountprice);
                if (nodes.discountPricePercent != 0)
                  setValue(item.amusementServiceId + "percentdiscount" + nodes.id, nodes.discountPricePercent);
              });
            });
            let tt2 = response?.getPromoCategoryCommisionByIdViewModel.map((item) => {
              let parsAmusementServiceFormFieldIds = JSON.parse(item.amusementServiceFormFieldIds);
              let tt = parsAmusementServiceFormFieldIds?.map((nodes) => {
                if (nodes.discountprice != 0)
                  setValue(item.amusementServiceId + "pricediscountCommision" + nodes.id, nodes.discountpriceCommision);
                if (nodes.discountPricePercent != 0)
                  setValue(
                    item.amusementServiceId + "percentdiscountCommision" + nodes.id,
                    nodes.discountPricePercentCommision,
                  );
              });
            });
          } else {
            SwalMessage({ title: "گروه کمیسیون مورد نظر پیدا نشد.", iSsuccess: false });
          }
        }
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    //ذخیره
    try {
      let pricediscountCommision = [];
      let objData = [];
      Object.keys(data).map((item) => {
        var inputValue = getValues(item);
        if (!_.isEmpty(inputValue) && !_.isUndefined(inputValue)) {
          let split = [];
          if (item.indexOf("pricediscountCommision") != -1 || item.indexOf("percentdiscountCommision") != -1) {
            if (item.indexOf("pricediscountCommision") != -1) {
              split = item.split("pricediscountCommision");
              pricediscountCommision.push({ serviceId: split[0], serviceItemId: split[1] });
            }

            let resITem = objData?.find((item) => item.amusementServiceId == split[0]);

            if (_.isUndefined(resITem)) {
              objData.push({
                amusementServiceId: split[0],
                amusementServiceFormFieldIds: [
                  {
                    id: split[1],
                    discountpriceCommision:
                      item.indexOf("pricediscountCommision") != -1 ? inputValue.replaceAll(",", "") : 0,
                  },
                ],
                PromoCategoryCommisionId: id,
              });
            } else {
              let objamusService = resITem.amusementServiceFormFieldIds.find((item) => item.id == split[1]);
              if (_.isUndefined(objamusService)) {
                resITem.amusementServiceFormFieldIds.push({
                  id: split[1],
                  discountpriceCommision:
                    item.indexOf("pricediscountCommision") != -1 ? inputValue.replaceAll(",", "") : 0,
                });
              } else {
                if (item.indexOf("pricediscountCommision") != -1)
                  objamusService.discountpriceCommision = inputValue.replaceAll(",", "");
              }
            }
          }
        }
      });
      let tt = objData?.map((item) => {
        return (item.amusementServiceFormFieldIds = JSON.stringify(item.amusementServiceFormFieldIds));
      });
      let response = await ApiPromocategorycommision.addAndEditPromoCategoryCommisionAmusmentServiceCommand({
        PromoCategoryCommisionAmusmentServiceId: id,
        promoCategoryCommisionAmusmentServiceModel: objData,
      });
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  // getAmusemntServices();
  const onSubmit1 = async (data) => {
    //جست وجو
    if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    if (data.groupIdList?.length > 0) data.groupIdList = _.toString(data.groupIdList?.map((item) => item.value));
    await getAmusemntServices(data.cityIdList, data.groupIdList);
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">کمیسیون گروه "{promoCategory}"</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              افزودن یا ویرایش کمیسیون گروه "{promoCategory}" برای تفریحات
            </span>
          </h3>
          <div className="">
            <Link className="btn btn-danger ml-3" to="/promoCategoryCommision">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </div>
        <form noValidate autoComplete="off" className="mt-3 px-4" onSubmit={handleSearchSubmit(onSubmit1)}>
          <Row className="pb-5 border-bottom">
            <Col sm="6" xl="3" className="ps-xl-1">
              <Controller
                name="cityIdList"
                control={searchControl}
                render={({ field }) => (
                  <SelectComponent
                    className=" mt-2"
                    placeholder=" شهر"
                    options={amusementCities?.map((item) => ({
                      value: item.id,
                      label: item.id + "-" + item.name,
                    }))}
                    isMulti
                    field={field}
                  />
                )}
              />
            </Col>
            <Col sm="6" xl="3" className="ps-xl-1">
              <Controller
                name="groupIdList"
                control={searchControl}
                render={({ field }) => (
                  <SelectComponent
                    className=" mt-2"
                    placeholder=" دسته تفریح"
                    options={amusementGroups?.map((item) => ({ value: item.id, label: item.title }))}
                    isMulti
                    field={field}
                  />
                )}
              />
            </Col>
            <Col xs="12" xl="auto" className="ps-xl-1">
              <Button
                variant="success"
                type="submit"
                className="mt-5 mt-md-2 px-5"
                color="success"
                style={{ height: "40px" }}
                disabled={isSearchSubmitting}
              >
                {isSearchSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SearchIcon />
                جستجو
              </Button>
              {/* <Button
                style={{ height: "40px" }}
                variant="light-danger"
                className="mt-5 mt-md-2 me-3"
                type="submit"
                disabled={isSearchSubmitting}
                onClick={() => tools.handleResetAdvanceSearchBox(watchSearch, resetSearch)}
              >
                {isSearchSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <i className="fas fa-refresh text-small"></i>
                حذف جستجو
              </Button> */}
            </Col>
          </Row>
        </form>
        {/*Start body */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-4 my-4">
            {!loadingData ? (
              treeViewData?.map((service) => (
                <Col key={service.serviceId} xs="12" className="mt-3 ">
                  <Accordion className="border">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${service.serviceId}-content`}
                      id={`panel${service.serviceId}-header`}
                    >
                      <div>{service.serviceName}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {service.amusementServiceReserveItems?.filter(item => item.reserveItemType != 1)?.map((item) => (
                        <div key={`${service.serviceId}-${item.id}`} style={{ marginBottom: "1rem" }}>
                          <h3 className="pb-3">{item.title}</h3>
                          <Row className="pb-4">
                            <Col xs="12" sm="6" md className="mb-5 mb-lg-0 opacity-50">
                              <HTMLInput
                                label="تخفیف به تومان"
                                registeredParams={{ ...register(`${service.serviceId}pricediscount${item.id}`) }}
                                className="form-control"
                                readOnly
                                disabled
                              />
                            </Col>
                            <Col xs="12" sm="6" md className="mb-5 mb-lg-0 opacity-50">
                              <HTMLInput
                                label="درصد تخفیف"
                                registeredParams={{ ...register(`${service.serviceId}percentdiscount${item.id}`) }}
                                className="form-control"
                                readOnly
                                disabled
                              />
                            </Col>
                            <Col xs="12" sm="6" md className="mb-5 mb-lg-0">
                              <HTMLInput
                                label="کمیسیون به تومان"
                                registeredParams={{ ...register(`${service.serviceId}pricediscountCommision${item.id}`) }}
                                className="form-control"
                                onChange={(e) => {
                                  setValue(
                                    `${service.serviceId}pricediscountCommision${item.id}`,
                                    e.target.value?.replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                                  );
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </Col>
              ))
            ) : (
              <div className="px-4 py-4">در حال دریافت اطلاعات ...</div>
            )}
          </div>
          <div className="card-footer">
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Link className="btn btn-danger ml-3" to="/promoCategoryCommision">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};
export default CreateEditAmusementServicePromoCategoryCommision;
